import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });
    return res.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isSuperOverDailyApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getSuperOverDailyPayload = (res) => res?.data ?? null;

/** GET /admin/arcade/super-over-daily */
export const listSuperOverDailyChallenges = ({
  from,
  to,
  enabled,
  limit = 50,
  offset = 0,
} = {}) => {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  if (enabled === true) params.set('enabled', 'true');
  if (enabled === false) params.set('enabled', 'false');
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  return authFetch(`/admin/arcade/super-over-daily?${params.toString()}`, { method: 'GET' });
};

/** GET /admin/arcade/super-over-daily/:id */
export const getSuperOverDailyChallenge = (id) =>
  authFetch(`/admin/arcade/super-over-daily/${id}`, { method: 'GET' });

/** POST /admin/arcade/super-over-daily */
export const createSuperOverDailyChallenge = (body) =>
  authFetch('/admin/arcade/super-over-daily', {
    method: 'POST',
    body: JSON.stringify(body),
  });

/** PATCH /admin/arcade/super-over-daily/:id */
export const patchSuperOverDailyChallenge = (id, body) =>
  authFetch(`/admin/arcade/super-over-daily/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

/** DELETE /admin/arcade/super-over-daily/:id */
export const deleteSuperOverDailyChallenge = (id) =>
  authFetch(`/admin/arcade/super-over-daily/${id}`, { method: 'DELETE' });
